<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirmSelectedValues($event)"
  (cancel)="cancel($event)"
  (alt)="alt($event)"
>
  <div class="flex--row custom-panel">
    <mat-form-field class="flex__child spacing--margin-half-top">
      <mat-label>{{ 'crops' | translate }}</mat-label>
      <mat-select
        #cropFilter
        multiple
        [(value)]="data.selectedCropIds"
        (selectionChange)="cropSelectionChange($event.value)"
        data-test="select-cropfields-dialog-cropsFilter"
      >
        <div class="custom-panel">
          <mat-option [value]="-1">{{ 'all' | translate }}</mat-option>
          <mat-divider></mat-divider>
          @for (crop of this.relevantCrops; track crop) {
            <mat-option [value]="crop.id">
              {{ crop.name }}
            </mat-option>
          }
        </div>
        <footer>
          <button mat-flat-button type="button" color="primary" (click)="cropFilter.toggle()">
            {{ 'ok' | translate }}
          </button>
        </footer>
      </mat-select>
    </mat-form-field>
  </div>
  @if (!data.disableSelectAll && getVisibleCropFieldCount() > 1) {
    <div class="mat-checkbox-row">
      <mat-checkbox
        color="primary"
        [checked]="areAllOptionsSelected"
        [indeterminate]="someSelected()"
        (change)="selectAllChanged($event.checked)"
        data-test="select-cropfields-dialog__select-all"
        >{{ 'selectAll' | translate }}
      </mat-checkbox>
    </div>
  }
  @if (!data.disableSelectAll && getVisibleCropFieldCount() > 1) {
    <mat-divider></mat-divider>
  }
  @for (control of formOptions; track control; let i = $index) {
    <div class="mat-checkbox-row">
      @if (isCropSelected(data.options[i].value.crop?.id)) {
        <mat-checkbox
          color="primary"
          class="text--body"
          [formControl]="control"
          (change)="select()"
        >
          {{ data.options[i].name }}
          @if (data.options[i].description) {
            <div class="text--label text--line-height-xs">
              {{ data.options[i].description }}
            </div>
          }
        </mat-checkbox>
      }
    </div>
  }
  @if (getVisibleCropFieldCount() === 0) {
    <div class="spacing--margin-all text-color--info-500">
      {{ 'noFieldsFound' | translate }}
    </div>
  }
  @if (data.options.length === 0) {
    <div>
      {{ data.emptyText }}
    </div>
  }
  <div class="spacing--margin-half-bottom"></div>
</agr-form-dialog>
